import React from 'react';
import PropTypes from 'prop-types';
import { FormCardSpaced } from 'modules/common';
import { AcceptButton, UpsellVideoEmbed, EnhancedUpsell, UpsellName, UpsellAction, Widgets } from './sections';
import { WIDGETS_MAP } from 'modules/common/widgets/tools';

function VolunteerDonation(props) {
  return (
    <>
      <FormCardSpaced>
        <UpsellName {...props} />
        <UpsellAction {...props} />
        <AcceptButton {...props} />
      </FormCardSpaced>

      <UpsellVideoEmbed {...props} />
      <EnhancedUpsell {...props} />

      <Widgets {...props} widgetOptions={VolunteerDonation.widgets} />
    </>
  );
}

VolunteerDonation.title = 'Volunteer';
VolunteerDonation.description = 'Ask donors to volunteer. This creates a Lead.';
VolunteerDonation.icon = 'upsell-volunteer';
VolunteerDonation.type = 'VOLUNTEER';
VolunteerDonation.widgets = [
  WIDGETS_MAP.EXITINTENTPOPUP.value,
  WIDGETS_MAP.SHOTCLOCK.value,
  WIDGETS_MAP.COUNTDOWN.value,
  WIDGETS_MAP.COUNTDOWNTOMIDNIGHT.value,
  WIDGETS_MAP.SOCIALLINKS.value,
  WIDGETS_MAP.ACCEPTBUTTONANIMATION.value,
  WIDGETS_MAP.POLLRESULTS.value,
];

VolunteerDonation.propTypes = {
  editedUpsell: PropTypes.object.isRequired,
  onUpdateEditedUpsell: PropTypes.func.isRequired,
};

export default VolunteerDonation;
